// Lightweight route-prefetcher: when the user hovers a product card we kick
// off the GET request for that product so the click feels instant. Cached
// per session in memory to avoid duplicate network calls.
import { getProduct, getReadyMade } from "./api";

const _seen = new Set();

export function prefetchCustom(id) {
  if (!id || _seen.has(`c-${id}`)) return;
  _seen.add(`c-${id}`);
  getProduct(id).catch(() => _seen.delete(`c-${id}`));
}

export function prefetchReadyMade(id) {
  if (!id || _seen.has(`r-${id}`)) return;
  _seen.add(`r-${id}`);
  getReadyMade(id).catch(() => _seen.delete(`r-${id}`));
}
